<template>
  <span
    class="inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-xs font-semibold"
    :class="category === 'molding' ? 'bg-amber-100 text-amber-800' : 'bg-teal-100 text-teal-800'"
  >
    <!-- One shade darker than the brief's original amber-500/teal-600: amber-500 (#F59E0B) is the exact
         default customer-mapping preset color (CustomerMappingList.vue's PRESET_COLORS[0]/DEFAULT_COLOR),
         and teal-500 (#14B8A6) is also a preset — both would read as "a customer" rather than "a category"
         next to the customer color legend and PO segments. amber-600/teal-700 keep the same hue family
         (design unchanged) but no longer coincide with a preset or PARTNER_PO_COLORS entry. -->
    <span class="h-1.5 w-1.5 rounded-full" :class="category === 'molding' ? 'bg-amber-600' : 'bg-teal-700'" />
    {{ label }}
  </span>
</template>

<script setup lang="ts">
  import type { CapacityCategory } from '@/types/capacityType';

  defineProps<{ category: CapacityCategory; label: string }>();
</script>
